/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Payment link with no amount, as the merchant sees it
 */
export type OpenPaymentLinkDTO = {
  createdAt?: string;
  description?: string;
  id?: string;
  /**
   * Number of successful payments
   */
  paymentCount?: number;
  /**
   * Link name in the payer URL; null when the link uses its id
   */
  slug?: string;
  status?: OpenPaymentLinkDTO.status;
  title?: string;
  /**
   * Sum of successful payments
   */
  totalCollected?: number;
};

export namespace OpenPaymentLinkDTO {
  export enum status {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
  }
}
